import { render } from "./Transporters.vue?vue&type=template&id=1ea9c336&scoped=true"
import script from "./Transporters.vue?vue&type=script&lang=js"
export * from "./Transporters.vue?vue&type=script&lang=js"

import "./Transporters.vue?vue&type=style&index=0&id=1ea9c336&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea9c336"]])

export default __exports__